import type { RouteObject } from "react-router-dom";

import { ConsentForm } from "./ConsentForm";
import { ScopeScreen } from "./ScopeScreen";

/**
 * Discovered by 06b's `router.tsx`. `/migrations/new/consent` is registered here because §B1's tree puts
 * `ConsentForm.tsx` in this directory; the route's path and the module's directory do not have to agree.
 * `:migrationId` matches 06b's `StageRedirect` and `stageRoute.pathForStage`.
 */
export const routes: RouteObject[] = [
  { path: "/migrations/new/consent", element: <ConsentForm /> },
  { path: "/migrations/:migrationId/scope", element: <ScopeScreen /> },
];
